var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShowPassIcon = function SvgShowPassIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M10 5.833c2.3 0 4.167 1.867 4.167 4.167 0 .542-.108 1.05-.3 1.525l2.433 2.433A9.85 9.85 0 0 0 19.158 10c-1.441-3.658-5-6.25-9.166-6.25a9.7 9.7 0 0 0-3.317.583l1.8 1.8c.475-.191.984-.3 1.525-.3M1.667 3.558l1.9 1.9.383.384A9.84 9.84 0 0 0 .833 10c1.442 3.658 5 6.25 9.167 6.25 1.292 0 2.525-.25 3.65-.7l.35.35 2.442 2.433 1.058-1.058L2.725 2.5zm4.608 4.609 1.292 1.291A2.4 2.4 0 0 0 7.5 10c0 1.383 1.117 2.5 2.5 2.5.184 0 .367-.025.542-.067l1.292 1.292a4.1 4.1 0 0 1-1.834.442A4.17 4.17 0 0 1 5.834 10c0-.658.166-1.275.441-1.833m3.592-.65 2.625 2.625.016-.134c0-1.383-1.116-2.5-2.5-2.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShowPassIcon);
export default ForwardRef;